import React from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
} from '@material-ui/core';
import { DragIndicator, MoreHoriz } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import { RESTAURANT_CHEF_EDIT } from '../../../../../constants/restaurantConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_RESTAURANT,
} from '../../../../../constants/RoleConsts';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import { isDragDisabled } from '../../../../../utils/formUtils';

const ChefListTable = (props) => {
  const {
    page,
    rowsPerPage,
    onOpenDrawer,
    onViewDetails,
    selectedValue,
    handleClose,
    onClickView,
    handleCellMenuClick,
    chefList,
    setChefList,
    handleChangePage,
    handleChangeRowsPerPage,
    handleDeletePopupOpen,
    permissions,
    setVisible,
    searchText,
    dragDisabled,
  } = props;

  return (
    <>
      <TableContainer>
        <Table className='list-table' aria-label='simple table'>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell className='w-40'>Name</TableCell>
              <TableCell className='w-25'>Restaurant</TableCell>
              <TableCell className='w-25'>Designation</TableCell>
              <TableCell className='w-25'>Specialisation</TableCell>
              <TableCell align='right'></TableCell>
            </TableRow>
          </TableHead>

          <DragDropContext
            onDragEnd={(event) =>
              handleOnDragEnd(event, setVisible, chefList, setChefList, false, page, rowsPerPage)
            }
            isDropDisabled={dragDisabled}
          >
            <Droppable droppableId='restaurants' isDropDisabled={dragDisabled}>
              {(provided) => (
                <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                  {(rowsPerPage > 0
                    ? chefList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : chefList
                  ).map((chefKey, key) => (
                    <Draggable
                      key={chefKey.id}
                      draggableId={chefKey.id}
                      index={key}
                      isDragDisabled={dragDisabled}
                    >
                      {(provided) => (
                        <TableRow
                          key={key}
                          className='border-white pointer'
                          onClick={(e) => {
                            onViewDetails(chefKey, e);
                          }}
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <TableCell>
                            {!dragDisabled && <DragIndicator className='res-menu-accordion-drag' />}
                          </TableCell>
                          <TableCell className='w-40'>{chefKey?.name}</TableCell>
                          <TableCell className='w-25'>{chefKey?.restaurantName}</TableCell>
                          <TableCell className='w-25'>{chefKey?.designation}</TableCell>
                          <TableCell className='w-25'>{chefKey?.specisalisation}</TableCell>
                          <TableCell align='right'>
                            {permissions[RBAC_TYPE_HOTEL_RESTAURANT] ===
                              RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                              <Button
                                aria-controls='simple-menu'
                                aria-haspopup='true'
                                onClick={(e) => {
                                  handleCellMenuClick(e, chefKey);
                                }}
                                className='showpopupInner'
                              >
                                <MoreHoriz className='showpopupInner' />
                              </Button>
                            )}
                            <Menu
                              id={key}
                              anchorEl={selectedValue?.anchorEl}
                              disableRestoreFocus
                              MenuListProps={{ autoFocusItem: false }}
                              keepMounted
                              open={
                                Boolean(selectedValue.anchorEl) && selectedValue.id === chefKey.id
                              }
                              onClose={handleClose}
                              className='shadow'
                            >
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => {
                                  onOpenDrawer(e, RESTAURANT_CHEF_EDIT);
                                }}
                              >
                                <CreateIcon className='me-2 action-menu-icon' />
                                Edit
                              </MenuItem>
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => {
                                  onClickView(e);
                                }}
                              >
                                <VisibilityIcon className='me-2 action-menu-icon' />
                                View
                              </MenuItem>
                              <MenuItem
                                className='pe-4'
                                onClick={(e) => handleDeletePopupOpen(e, chefKey.id)}
                              >
                                <DeleteForeverIcon className='me-2 action-menu-icon' />
                                Delete
                              </MenuItem>
                            </Menu>
                          </TableCell>
                        </TableRow>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </TableBody>
              )}
            </Droppable>
          </DragDropContext>

          <TableFooter>
            <TableRow className='paginator'>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                count={chefList.length}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: { 'aria-label': 'rows per page' },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </>
  );
};

export default ChefListTable;
